import React, { useEffect, useState } from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { FaCoins } from 'react-icons/fa';
import confetti from 'canvas-confetti';

// ✅ Coin Bounce Animation
const bounce = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-10px); }
`;

// ✅ Styled Components
const StyledContainer = styled(Container)`
  background: radial-gradient(circle, #0f0f0f, #000);
  color: #FFFFFF;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 30px 20px;
`;

const CoinsIcon = styled(FaCoins)`
  font-size: 64px;
  color: #FFB800;
  animation: ${bounce} 1s infinite ease-in-out;
  margin-bottom: 20px;
`;

const CoinText = styled.p`
  font-size: 26px;
  font-weight: 700;
  margin-bottom: 15px;
  color: #FFD700;
`;

const RewardMessage = styled.div`
  background-color: #1E1E1E;
  padding: 16px 20px;
  font-size: 18px;
  font-weight: bold;
  color: #00FFA3;
  border-radius: 12px;
  margin-bottom: 30px;
  border: 2px dashed #00FFA3;
  max-width: 360px;
`;

const StreakMessage = styled.div`
  background-color: #232830;
  padding: 10px 15px;
  font-size: 16px;
  font-weight: bold;
  color: #FF7C24;
  border-radius: 10px;
  margin-bottom: 20px;
`;

const ContinueButton = styled(Button)`
  background-color: #FF7C24;
  border-color: #FF7C24;
  font-size: 18px;
  font-weight: bold;
  border-radius: 14px;
  padding: 14px 30px;
  width: 100%;
  max-width: 300px;
  transition: transform 0.2s ease;

  &:hover {
    background-color: #ffa94d;
    transform: scale(1.05);
  }
`;

const PostActivationStreakCommitRewardPage = () => {
  const navigate = useNavigate();
  const [coins, setCoins] = useState(0);

  // ✅ Animate coins from 0 to 10 and trigger confetti
  useEffect(() => {
    let counter = 0;
    const interval = setInterval(() => {
      counter += 1;
      setCoins(counter);
      if (counter === 10) {
        clearInterval(interval);
        confetti({
          particleCount: 100,
          spread: 70,
          origin: { y: 0.6 },
        });
      }
    }, 100);
    return () => clearInterval(interval);
  }, []);

  const handleContinue = () => {
    navigate('/course-landing');
  };

  return (
    <StyledContainer>
      <CoinsIcon />
      <CoinText>🎉 You’ve earned {coins} coins!</CoinText>
      <RewardMessage>🔥 Amazing commitment – daily progress adds up to lifelong success!</RewardMessage>
      <StreakMessage>📈 Your streak starts now – stay consistent to unlock mastery!</StreakMessage>
      <ContinueButton onClick={handleContinue}>Continue</ContinueButton>
    </StyledContainer>
  );
};

export default PostActivationStreakCommitRewardPage;
